<template>
  <div>
    {{ text }}
    <v-progress-circular class="ml-5" :rotate="360" :size="45" :width="5" :value="value" color="white">
      {{ value }}
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'ProgressCircular',
  props: ['value', 'text']
}
</script>

<style scoped>
.notifications {
  position: absolute;
  height: 12px;
  width: 12px;
  font-size: 0.5rem;
  border-radius: 50%;
  background-color: #ff0000;
  z-index: 5;
  margin-left: 1rem;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
